export const SAMPLE_DATA = {
  json: {
    original: `{
  "user": {
    "id": 123,
    "name": "John Doe",
    "email": "john@example.com",
    "roles": ["admin", "user"],
    "settings": {
      "theme": "dark",
      "notifications": true
    }
  }
}`,
    modified: `{
  "user": {
    "id": 123,
    "name": "John Smith",
    "email": "john.smith@example.com",
    "roles": ["user", "editor"],
    "settings": {
      "theme": "light",
      "notifications": true,
      "language": "en"
    },
    "lastLogin": "2024-01-15"
  }
}`
  },
  xml: {
    original: `<?xml version="1.0" encoding="UTF-8"?>
<config>
  <database>
    <host>localhost</host>
    <port>5432</port>
    <name>myapp</name>
  </database>
  <cache>
    <enabled>true</enabled>
    <ttl>3600</ttl>
  </cache>
</config>`,
    modified: `<?xml version="1.0" encoding="UTF-8"?>
<config>
  <database>
    <host>db.example.com</host>
    <port>5432</port>
    <name>myapp_prod</name>
    <ssl>true</ssl>
  </database>
  <cache>
    <enabled>true</enabled>
    <ttl>7200</ttl>
    <provider>redis</provider>
  </cache>
</config>`
  },
  yaml: {
    original: `apiVersion: apps/v1
kind: Deployment
metadata:
  name: webapp
spec:
  replicas: 2
  template:
    spec:
      containers:
      - name: app
        image: myapp:1.0.0
        ports:
        - containerPort: 8080
        env:
        - name: ENV
          value: staging`,
    modified: `apiVersion: apps/v1
kind: Deployment
metadata:
  name: webapp
  labels:
    version: v2
spec:
  replicas: 3
  template:
    spec:
      containers:
      - name: app
        image: myapp:1.1.0
        ports:
        - containerPort: 8080
        env:
        - name: ENV
          value: production
        - name: LOG_LEVEL
          value: info`
  },
  csv: {
    original: `id,name,email,status
1,Alice,alice@example.com,active
2,Bob,bob@example.com,active
3,Charlie,charlie@example.com,inactive`,
    modified: `id,name,email,status
1,Alice,alice@company.com,active
2,Bob,bob@example.com,inactive
4,David,david@example.com,active`
  },
  toml: {
    original: `[package]
name = "myapp"
version = "1.0.0"
edition = "2021"

[dependencies]
serde = "1.0"
tokio = { version = "1.0", features = ["full"] }

[dev-dependencies]
test-utils = "0.1"`,
    modified: `[package]
name = "myapp"
version = "1.1.0"
edition = "2021"
authors = ["John Doe"]

[dependencies]
serde = { version = "1.0", features = ["derive"] }
tokio = { version = "1.0", features = ["full"] }
axum = "0.6"

[dev-dependencies]
test-utils = "0.2"`
  },
  env: {
    original: `# Database Configuration
DB_HOST=localhost
DB_PORT=5432
DB_NAME=myapp
DB_USER=admin

# API Settings
API_KEY=abc123xyz
API_TIMEOUT=30
DEBUG_MODE=true`,
    modified: `# Database Configuration
DB_HOST=prod-db.example.com
DB_PORT=5432
DB_NAME=myapp_production
DB_USER=prod_admin
DB_PASSWORD=secret123

# API Settings
API_KEY=prod-key-456
API_TIMEOUT=60
DEBUG_MODE=false
LOG_LEVEL=info`
  },
  dockerfile: {
    original: `FROM node:16-alpine
WORKDIR /app
COPY package*.json ./
RUN npm ci --only=production
COPY . .
EXPOSE 3000
CMD ["node", "server.js"]`,
    modified: `FROM node:18-alpine
WORKDIR /app
COPY package*.json ./
RUN npm ci --only=production && npm cache clean --force
COPY . .
EXPOSE 3000
HEALTHCHECK --interval=30s CMD node healthcheck.js
USER node
CMD ["node", "server.js"]`
  },
  text: {
    original: `# Project Configuration

## Server Settings
- Port: 8080
- Host: localhost
- SSL: disabled

## Features
- Authentication enabled
- Logging level: info
- Cache enabled`,
    modified: `# Project Configuration

## Server Settings
- Port: 8080
- Host: 0.0.0.0
- SSL: enabled
- Timeout: 30s

## Features
- Authentication enabled
- Logging level: debug
- Cache disabled
- Monitoring enabled`
  }
};

export function getSampleData(format) {
  // Map various formats to the base formats we have samples for
  const formatMap = {
    json: ['json', 'tsconfig', 'eslint', 'prettier', 'jest', 'babel', 'composer', 'vercel', 'arm', 'grafana', 'api', 'package'],
    xml: ['xml', 'maven', 'nuget'],
    yaml: ['yaml', 'kubernetes', 'docker-compose', 'ansible', 'helm', 'github', 'gitlab', 'circleci', 'travis', 'appveyor', 'bitbucket', 'cloudformation', 'conda', 'prometheus'],
    csv: ['csv'],
    toml: ['toml', 'cargo', 'poetry', 'pipfile'],
    env: ['env'],
    dockerfile: ['dockerfile'],
    text: ['ini', 'properties', 'netlify', 'editorconfig', 'terraform', 'nginx', 'makefile', 'cmake', 'gitignore', 'graphql', 'sql', 'python', 'javascript', 'typescript', 'gradle', 'gomod', 'ruby', 'txt']
  };

  // Find which base format this belongs to
  for (const [baseFormat, formats] of Object.entries(formatMap)) {
    if (formats.some(f => format.toLowerCase().includes(f))) {
      return SAMPLE_DATA[baseFormat];
    }
  }

  // Default to text for unknown formats
  return SAMPLE_DATA.text;
}
